import React from 'react';
import { Tag } from 'antd';
import UserRoles, { UserRole } from '../../enums/userRoles';
import { getNameOfRole } from '../../services/account.service';

interface RoleBadgeProps {
  role: UserRole | null | undefined;
}

const RoleBadge: React.FC<RoleBadgeProps> = ({ role }) => {
  if (!role) return null;
  let color = 'default';
  if (role === UserRoles.ADMIN) {
    color = 'blue';
  } else if (role === UserRoles.OWNER) {
    color = 'purple';
  }
  return <Tag color={color}>{getNameOfRole(role)}</Tag>;
};

export default RoleBadge;
